import { isAxiosError } from "axios";

const PLATFORM_ID_IN_PATH =
  /\/platforms\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i;

export const extractPlatformIdFromRequestUrl = (
  requestUrl: string | undefined,
): string | undefined => {
  if (!requestUrl) {
    return undefined;
  }

  return requestUrl.match(PLATFORM_ID_IN_PATH)?.[1];
};

export const extractPlatformIdFromAxiosError = (error: unknown): string | undefined => {
  if (!isAxiosError(error)) {
    return undefined;
  }

  return extractPlatformIdFromRequestUrl(error.config?.url);
};
